/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InstagramRouteImport } from './routes/instagram'
import { Route as FichaRouteImport } from './routes/ficha'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSistemaRouteImport } from './routes/_app/sistema'
import { Route as AppFinanceiroRouteImport } from './routes/_app/financeiro'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppConversasRouteImport } from './routes/_app/conversas'
import { Route as AppClinicaRouteImport } from './routes/_app/clinica'
import { Route as AppAgendaRouteImport } from './routes/_app/agenda'
import { Route as AppWikiIndexRouteImport } from './routes/_app/wiki/index'
import { Route as AppSistemaIndexRouteImport } from './routes/_app/sistema/index'
import { Route as AppPessoasIndexRouteImport } from './routes/_app/pessoas/index'
import { Route as AppClinicaIndexRouteImport } from './routes/_app/clinica/index'
import { Route as AppCadastroIndexRouteImport } from './routes/_app/cadastro/index'
import { Route as AppWikiSlugRouteImport } from './routes/_app/wiki/$slug'
import { Route as AppPessoaIdRouteImport } from './routes/_app/pessoa/$id'
import { Route as AppCadastroIdRouteImport } from './routes/_app/cadastro/$id'
import { Route as AppClinicaTermoIdRouteImport } from './routes/_app/clinica/termo.$id'
import { Route as AppClinicaManualIdRouteImport } from './routes/_app/clinica/manual.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InstagramRoute = InstagramRouteImport.update({
  id: '/instagram',
  path: '/instagram',
  getParentRoute: () => rootRouteImport,
} as any)
const FichaRoute = FichaRouteImport.update({
  id: '/ficha',
  path: '/ficha',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSistemaRoute = AppSistemaRouteImport.update({
  id: '/sistema',
  path: '/sistema',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceiroRoute = AppFinanceiroRouteImport.update({
  id: '/financeiro',
  path: '/financeiro',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppConversasRoute = AppConversasRouteImport.update({
  id: '/conversas',
  path: '/conversas',
  getParentRoute: () => AppRoute,
} as any)
const AppClinicaRoute = AppClinicaRouteImport.update({
  id: '/clinica',
  path: '/clinica',
  getParentRoute: () => AppRoute,
} as any)
const AppAgendaRoute = AppAgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => AppRoute,
} as any)
const AppWikiIndexRoute = AppWikiIndexRouteImport.update({
  id: '/wiki/',
  path: '/wiki/',
  getParentRoute: () => AppRoute,
} as any)
const AppSistemaIndexRoute = AppSistemaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSistemaRoute,
} as any)
const AppPessoasIndexRoute = AppPessoasIndexRouteImport.update({
  id: '/pessoas/',
  path: '/pessoas/',
  getParentRoute: () => AppRoute,
} as any)
const AppClinicaIndexRoute = AppClinicaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppClinicaRoute,
} as any)
const AppCadastroIndexRoute = AppCadastroIndexRouteImport.update({
  id: '/cadastro/',
  path: '/cadastro/',
  getParentRoute: () => AppRoute,
} as any)
const AppWikiSlugRoute = AppWikiSlugRouteImport.update({
  id: '/wiki/$slug',
  path: '/wiki/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppPessoaIdRoute = AppPessoaIdRouteImport.update({
  id: '/pessoa/$id',
  path: '/pessoa/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCadastroIdRoute = AppCadastroIdRouteImport.update({
  id: '/cadastro/$id',
  path: '/cadastro/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppClinicaTermoIdRoute = AppClinicaTermoIdRouteImport.update({
  id: '/termo/$id',
  path: '/termo/$id',
  getParentRoute: () => AppClinicaRoute,
} as any)
const AppClinicaManualIdRoute = AppClinicaManualIdRouteImport.update({
  id: '/manual/$id',
  path: '/manual/$id',
  getParentRoute: () => AppClinicaRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/ficha': typeof FichaRoute
  '/instagram': typeof InstagramRoute
  '/login': typeof LoginRoute
  '/agenda': typeof AppAgendaRoute
  '/clinica': typeof AppClinicaRouteWithChildren
  '/conversas': typeof AppConversasRoute
  '/dashboard': typeof AppDashboardRoute
  '/financeiro': typeof AppFinanceiroRoute
  '/sistema': typeof AppSistemaRouteWithChildren
  '/cadastro/$id': typeof AppCadastroIdRoute
  '/pessoa/$id': typeof AppPessoaIdRoute
  '/wiki/$slug': typeof AppWikiSlugRoute
  '/cadastro/': typeof AppCadastroIndexRoute
  '/clinica/': typeof AppClinicaIndexRoute
  '/pessoas/': typeof AppPessoasIndexRoute
  '/sistema/': typeof AppSistemaIndexRoute
  '/wiki/': typeof AppWikiIndexRoute
  '/clinica/manual/$id': typeof AppClinicaManualIdRoute
  '/clinica/termo/$id': typeof AppClinicaTermoIdRoute
}
export interface FileRoutesByTo {
  '/ficha': typeof FichaRoute
  '/instagram': typeof InstagramRoute
  '/login': typeof LoginRoute
  '/agenda': typeof AppAgendaRoute
  '/conversas': typeof AppConversasRoute
  '/dashboard': typeof AppDashboardRoute
  '/financeiro': typeof AppFinanceiroRoute
  '/': typeof AppIndexRoute
  '/cadastro/$id': typeof AppCadastroIdRoute
  '/pessoa/$id': typeof AppPessoaIdRoute
  '/wiki/$slug': typeof AppWikiSlugRoute
  '/cadastro': typeof AppCadastroIndexRoute
  '/clinica': typeof AppClinicaIndexRoute
  '/pessoas': typeof AppPessoasIndexRoute
  '/sistema': typeof AppSistemaIndexRoute
  '/wiki': typeof AppWikiIndexRoute
  '/clinica/manual/$id': typeof AppClinicaManualIdRoute
  '/clinica/termo/$id': typeof AppClinicaTermoIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/ficha': typeof FichaRoute
  '/instagram': typeof InstagramRoute
  '/login': typeof LoginRoute
  '/_app/agenda': typeof AppAgendaRoute
  '/_app/clinica': typeof AppClinicaRouteWithChildren
  '/_app/conversas': typeof AppConversasRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/financeiro': typeof AppFinanceiroRoute
  '/_app/sistema': typeof AppSistemaRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/cadastro/$id': typeof AppCadastroIdRoute
  '/_app/pessoa/$id': typeof AppPessoaIdRoute
  '/_app/wiki/$slug': typeof AppWikiSlugRoute
  '/_app/cadastro/': typeof AppCadastroIndexRoute
  '/_app/clinica/': typeof AppClinicaIndexRoute
  '/_app/pessoas/': typeof AppPessoasIndexRoute
  '/_app/sistema/': typeof AppSistemaIndexRoute
  '/_app/wiki/': typeof AppWikiIndexRoute
  '/_app/clinica/manual/$id': typeof AppClinicaManualIdRoute
  '/_app/clinica/termo/$id': typeof AppClinicaTermoIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ficha'
    | '/instagram'
    | '/login'
    | '/agenda'
    | '/clinica'
    | '/conversas'
    | '/dashboard'
    | '/financeiro'
    | '/sistema'
    | '/cadastro/$id'
    | '/pessoa/$id'
    | '/wiki/$slug'
    | '/cadastro/'
    | '/clinica/'
    | '/pessoas/'
    | '/sistema/'
    | '/wiki/'
    | '/clinica/manual/$id'
    | '/clinica/termo/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/ficha'
    | '/instagram'
    | '/login'
    | '/agenda'
    | '/conversas'
    | '/dashboard'
    | '/financeiro'
    | '/'
    | '/cadastro/$id'
    | '/pessoa/$id'
    | '/wiki/$slug'
    | '/cadastro'
    | '/clinica'
    | '/pessoas'
    | '/sistema'
    | '/wiki'
    | '/clinica/manual/$id'
    | '/clinica/termo/$id'
  id:
    | '__root__'
    | '/_app'
    | '/ficha'
    | '/instagram'
    | '/login'
    | '/_app/agenda'
    | '/_app/clinica'
    | '/_app/conversas'
    | '/_app/dashboard'
    | '/_app/financeiro'
    | '/_app/sistema'
    | '/_app/'
    | '/_app/cadastro/$id'
    | '/_app/pessoa/$id'
    | '/_app/wiki/$slug'
    | '/_app/cadastro/'
    | '/_app/clinica/'
    | '/_app/pessoas/'
    | '/_app/sistema/'
    | '/_app/wiki/'
    | '/_app/clinica/manual/$id'
    | '/_app/clinica/termo/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  FichaRoute: typeof FichaRoute
  InstagramRoute: typeof InstagramRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instagram': {
      id: '/instagram'
      path: '/instagram'
      fullPath: '/instagram'
      preLoaderRoute: typeof InstagramRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ficha': {
      id: '/ficha'
      path: '/ficha'
      fullPath: '/ficha'
      preLoaderRoute: typeof FichaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sistema': {
      id: '/_app/sistema'
      path: '/sistema'
      fullPath: '/sistema'
      preLoaderRoute: typeof AppSistemaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/financeiro': {
      id: '/_app/financeiro'
      path: '/financeiro'
      fullPath: '/financeiro'
      preLoaderRoute: typeof AppFinanceiroRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/conversas': {
      id: '/_app/conversas'
      path: '/conversas'
      fullPath: '/conversas'
      preLoaderRoute: typeof AppConversasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clinica': {
      id: '/_app/clinica'
      path: '/clinica'
      fullPath: '/clinica'
      preLoaderRoute: typeof AppClinicaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agenda': {
      id: '/_app/agenda'
      path: '/agenda'
      fullPath: '/agenda'
      preLoaderRoute: typeof AppAgendaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/wiki/': {
      id: '/_app/wiki/'
      path: '/wiki'
      fullPath: '/wiki/'
      preLoaderRoute: typeof AppWikiIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sistema/': {
      id: '/_app/sistema/'
      path: '/'
      fullPath: '/sistema/'
      preLoaderRoute: typeof AppSistemaIndexRouteImport
      parentRoute: typeof AppSistemaRoute
    }
    '/_app/pessoas/': {
      id: '/_app/pessoas/'
      path: '/pessoas'
      fullPath: '/pessoas/'
      preLoaderRoute: typeof AppPessoasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clinica/': {
      id: '/_app/clinica/'
      path: '/'
      fullPath: '/clinica/'
      preLoaderRoute: typeof AppClinicaIndexRouteImport
      parentRoute: typeof AppClinicaRoute
    }
    '/_app/cadastro/': {
      id: '/_app/cadastro/'
      path: '/cadastro'
      fullPath: '/cadastro/'
      preLoaderRoute: typeof AppCadastroIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/wiki/$slug': {
      id: '/_app/wiki/$slug'
      path: '/wiki/$slug'
      fullPath: '/wiki/$slug'
      preLoaderRoute: typeof AppWikiSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoa/$id': {
      id: '/_app/pessoa/$id'
      path: '/pessoa/$id'
      fullPath: '/pessoa/$id'
      preLoaderRoute: typeof AppPessoaIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/$id': {
      id: '/_app/cadastro/$id'
      path: '/cadastro/$id'
      fullPath: '/cadastro/$id'
      preLoaderRoute: typeof AppCadastroIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clinica/termo/$id': {
      id: '/_app/clinica/termo/$id'
      path: '/termo/$id'
      fullPath: '/clinica/termo/$id'
      preLoaderRoute: typeof AppClinicaTermoIdRouteImport
      parentRoute: typeof AppClinicaRoute
    }
    '/_app/clinica/manual/$id': {
      id: '/_app/clinica/manual/$id'
      path: '/manual/$id'
      fullPath: '/clinica/manual/$id'
      preLoaderRoute: typeof AppClinicaManualIdRouteImport
      parentRoute: typeof AppClinicaRoute
    }
  }
}

interface AppClinicaRouteChildren {
  AppClinicaIndexRoute: typeof AppClinicaIndexRoute
  AppClinicaManualIdRoute: typeof AppClinicaManualIdRoute
  AppClinicaTermoIdRoute: typeof AppClinicaTermoIdRoute
}

const AppClinicaRouteChildren: AppClinicaRouteChildren = {
  AppClinicaIndexRoute: AppClinicaIndexRoute,
  AppClinicaManualIdRoute: AppClinicaManualIdRoute,
  AppClinicaTermoIdRoute: AppClinicaTermoIdRoute,
}

const AppClinicaRouteWithChildren = AppClinicaRoute._addFileChildren(
  AppClinicaRouteChildren,
)

interface AppSistemaRouteChildren {
  AppSistemaIndexRoute: typeof AppSistemaIndexRoute
}

const AppSistemaRouteChildren: AppSistemaRouteChildren = {
  AppSistemaIndexRoute: AppSistemaIndexRoute,
}

const AppSistemaRouteWithChildren = AppSistemaRoute._addFileChildren(
  AppSistemaRouteChildren,
)

interface AppRouteChildren {
  AppAgendaRoute: typeof AppAgendaRoute
  AppClinicaRoute: typeof AppClinicaRouteWithChildren
  AppConversasRoute: typeof AppConversasRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppFinanceiroRoute: typeof AppFinanceiroRoute
  AppSistemaRoute: typeof AppSistemaRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppCadastroIdRoute: typeof AppCadastroIdRoute
  AppPessoaIdRoute: typeof AppPessoaIdRoute
  AppWikiSlugRoute: typeof AppWikiSlugRoute
  AppCadastroIndexRoute: typeof AppCadastroIndexRoute
  AppPessoasIndexRoute: typeof AppPessoasIndexRoute
  AppWikiIndexRoute: typeof AppWikiIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAgendaRoute: AppAgendaRoute,
  AppClinicaRoute: AppClinicaRouteWithChildren,
  AppConversasRoute: AppConversasRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppFinanceiroRoute: AppFinanceiroRoute,
  AppSistemaRoute: AppSistemaRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppCadastroIdRoute: AppCadastroIdRoute,
  AppPessoaIdRoute: AppPessoaIdRoute,
  AppWikiSlugRoute: AppWikiSlugRoute,
  AppCadastroIndexRoute: AppCadastroIndexRoute,
  AppPessoasIndexRoute: AppPessoasIndexRoute,
  AppWikiIndexRoute: AppWikiIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  FichaRoute: FichaRoute,
  InstagramRoute: InstagramRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
